import { render, staticRenderFns } from "./HorseFiche_old.vue?vue&type=template&id=f7bdc070&"
import script from "./HorseFiche_old.vue?vue&type=script&lang=js&"
export * from "./HorseFiche_old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports